<template>
  <div class="donut-chart">
    <Chart :title="title" :currency="settings.currency">
      <template #chart>
        <HighChart v-if="chartData" :options="mergedChartData" />
      </template>
      <template #widget-options>
        <div class="actions-wrapper">
          <YearSelect v-model="financialPeriodId" />
          <slot name="widget-options" />
        </div>
      </template>
    </Chart>
  </div>
</template>

<script>
import { customChartData } from './custom-chart-data-'
// Libraries
import { capitalize, merge } from 'lodash'
// Components
import { Chart as HighChart } from 'highcharts-vue'
import Chart from '../Chart'
import YearSelect from '@/modules/financial/shared/YearSelect'

export default {
  inject: ['chartName'],

  components: {
    Chart,
    HighChart,
    YearSelect
  },

  props: {
    title: String,
    apiFn: {
      type: Function,
      required: true
    }
  },

  data: () => ({
    chartData: null,
    financialPeriodId: null
  }),

  computed: {
    mergedChartData() {
      if (!this.chartData) return
      return merge(this.chartData.chart, this.customChartData)
    }
  },

  watch: {
    financialPeriodId: 'getChartData'
  },

  created() {
    this.customChartData = customChartData.call(this)
  },

  methods: {
    getChartData(financialPeriodId) {
      this.apiFn(financialPeriodId, this.chartName).then(({ data }) => {
        this.chartData = data.result
        this.departments = data.result.chart.series[0].data
          .filter(dep => dep.y)
          .map((dep, index) => ({
            id: index + 1,
            label: capitalize(dep.name),
            value: dep.name
          }))
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.donut-chart {
  .actions-wrapper {
    display flex
    align-items center
    justify-content flex-end
  }
}
</style>
